import { useLocaleContext } from 'providers/LocaleProvider';
import React from 'react';
import styled from 'styled-components';
import { Title } from '@seaweb/coral/components/Typography';
import { trackEnterContactForm } from 'utils/ga';
import LinkButton from 'components/shared/LinkButton';

const HelpSection = styled.div`
  height: 171px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f9fbfe;
`;

const HelpTitle = styled(Title)`
  font-size: 20px;
  font-weight: bold;
  color: #202325;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  text-align: center;
`;

const StyledLinkButton = styled(LinkButton)`
  width: 114px;
  height: 40px;
  border-radius: 20px;
  padding: 4px 0;
  background: linear-gradient(140deg, #3ac4fb 9%, #178bec 93%);
`;

function ContactSection() {
  const { locale: t } = useLocaleContext();

  return (
    <HelpSection>
      <HelpTitle>{t('hc.contact.need_help')}</HelpTitle>
      <StyledLinkButton
        radius={20}
        href="/contact"
        onClick={trackEnterContactForm}
      >
        {t('hc.contact.contact_us')}
      </StyledLinkButton>
    </HelpSection>
  );
}

export default ContactSection;
